
import s from './index.module.css';
import Time from '../UI/Time';
import TimeEnd from '../UI/TimeEnd';
import Number from '../UI/Number';
import Month from '../UI/Month';
import {PlusIcon} from '@/utils/icons';
import classNames from 'classnames';

const Annually = ({regularity, changeRegularity, addRegularity, deleteRegularity, timeRange, className=''}) => {

    return (
        <div className={classNames(s.annuallyWrapper, {[className]: !!className})}>
            {
                regularity.annually.map((el, index) => {
                    return (
                        <div key={el.id} className={s.line}>
                            <div className={s.numberWrapper}>
                                <div className={s.text}>Месяц</div>
                                <Month 
                                    changeRegularity={changeRegularity}
                                    index={index}
                                    month={el.month}
                                    firstField='annually'
                                />
                            </div>
                            <div className={s.numberWrapper}>
                                <div className={s.text}>Число</div>
                                <Number 
                                    changeRegularity={changeRegularity}
                                    index={index}
                                    number={el.number}
                                    firstField='annually'
                                />
                            </div>
                            <div className={s.timeWrapper}>
                                <div className={s.text}>Время</div>
                                
                                <Time 
                                    changeRegularity={changeRegularity} 
                                    index={index} 
                                    minutes={el.minutes} 
                                    hour={el.hour} 
                                    firstField='annually'
                                />

                                {
                                    timeRange && '-'
                                }

                                {
                                    timeRange && (
                                        <TimeEnd
                                            changeRegularity={changeRegularity} 
                                            index={index} 
                                            minutesEnd={el.minutesEnd} 
                                            hourEnd={el.hourEnd} 
                                            firstField='annually'
                                        />
                                    )
                                }

                            </div>
                            <div className={s.actionsWrapper}>
                                <div
                                    onClick={()=>{deleteRegularity(index, 'annually')}} 
                                    className={classNames(s.actionButton, s.actionButtonRemove)}>
                                    <PlusIcon />
                                </div>
                            </div>
                            
                            
                        </div>
                    )
                })
            }
            <div className={classNames(s.actionsWrapper, 'actionsWrapper')}>
                <div className={classNames(s.actionButton, 'add')}
                        onClick={()=>{addRegularity('annually')}}>
                    <PlusIcon />
                </div>
            </div>
            
        </div>
        
    )
}

export default Annually;